import { getPaymentsEligibleSolutions } from '~/helpers/selfcare';
var genericRootSegmentation = {
  mdm: 'MDM_AFTER_SALES',
  marketplace: 'MARKETPLACE_AFTER_SALES'
};
export var OPEN_INCIDENT_STATUS = ['DELIVERED', 'DELIVERY_IN_PROGRESS', 'DELIVERY_TO_CARRIER'];
export var EXCHANGE = 'exchange';
export var REFUND = 'refund';
export var CREDIT_NOTE = 'creditNote';
export var ELIGIBLE_CARRIER_TYPES = ['COLISSIMO', 'COLISSIMO_MEUBLE', 'COLISSIMO_POINT_RETRAIT_DECO', 'COLISSIMO_POINT_RETRAIT_MLP', 'CHRONOPOST', 'CHRONOPOST_LV1_MLP'];
export var THEMATICS = [{
  id: 'them1',
  label: {
    fr: 'Je rencontre un problème sur mon article, ma commande ou ma facture',
    en: 'Problem with a product/order/invoice',
    de: 'Problem mit einem Produkt / einer Bestellung / Rechnung',
    es: 'Problema con un producto / pedido / factura',
    it: 'Problema con un prodotto/ordine/fattura',
    nl: 'Probleem met een product / bestelling / factuur',
    pt: 'Problema com um produto/encomenda/fatura'
  },
  questions: {
    default: ['product-return', 'product-not-shipped', 'refuse-product', 'contact-to-refund', 'absence-during-delivery', 'article-defect', 'invoice-not-received', 'modify-invoice-address', 'other-question'],
    ES: ['product-return', 'product-not-shipped', 'refuse-product', 'contact-to-refund', 'absence-during-delivery', 'article-defect', 'invoice-not-received', 'other-question'],
    DE: ['product-return', 'product-not-shipped', 'refuse-product', 'contact-to-refund', 'absence-during-delivery', 'article-defect', 'invoice-not-received', 'other-question']
  }
}, {
  id: 'them2',
  label: {
    fr: 'Je souhaite modifier ou annuler ma commande',
    en: 'Cancelling or modifying an order',
    de: 'Meine Bestellung ändern oder stornieren',
    es: 'Modificar o anular mi pedido',
    it: "Modificare o cancellare l'ordine",
    nl: 'Mijn bestelling wijzigen of annuleren',
    pt: 'Modificar ou cancelar a minha encomenda'
  },
  questions: {
    default: ['cancel-product-command', 'modify-shipping-address', 'add-article']
  }
}, {
  id: 'them3',
  label: {
    fr: 'Je souhaite des informations sur un échange, une livraison ou une commande',
    en: 'Information about an exchange, a delivery or an order',
    de: 'Informationen zur Retoure, Lieferung oder zu meiner Bestellung',
    es: 'Información sobre un cambio, una entrega o mi pedido',
    it: 'Informazioni su un cambio, una consegna o un ordine',
    nl: 'Informatie over een omruiling, een levering of mijn bestelling',
    pt: 'Informações sobre uma troca, uma entrega ou a minha encomenda'
  },
  questions: {
    default: ['shipping-details', 'furniture-received', 'exchange-product'],
    UK: ['shipping-details', 'furniture-received']
  }
}, {
  id: 'them4',
  label: {
    fr: "Je souhaite des informations sur ma carte cadeau, mon bon d'achat ou mon avoir",
    en: 'Problem or question relating to purchase voucher',
    de: 'Ich habe ein Problem bzw. eine Frage zu meiner Geschenkkarte, Gutschein oder Guthaben',
    es: 'Problema o consulta sobre mi tarjeta regalo, gesto comercial en forma de vale de compra o vale',
    it: 'Problema o domanda sulla mia carta regalo, buono acquisto o credito',
    nl: 'Probleem met of vraag over mijn cadeaubon, aankoopbon of tegoed',
    pt: 'Problema ou pergunta sobre o meu cartão-presente, ato comercial em forma de vale de compra ou vale'
  },
  questions: {
    default: ['gift-card-order-web-not-received', 'need-gift-card-invoice', 'purchase-voucher-lost', 'purchase-voucher-not-received', 'credit-note-not-received', 'lost-credit-note', 'cannot-use-gift-card', 'cannot-use-purchase-voucher', 'cannot-use-credit-note'],
    UK: ['purchase-voucher-lost', 'purchase-voucher-not-received', 'cannot-use-purchase-voucher']
  }
}, {
  id: 'them5',
  label: {
    fr: 'Données personnelles',
    en: 'Personal data',
    de: 'Personenbezogene Daten',
    es: 'Datos personales',
    it: 'Dati personali',
    nl: 'Persoonlijke gegevens',
    pt: 'Dados pessoais'
  },
  questions: {
    default: ['rgpd']
  }
}];
export var QUESTIONS = {
  'product-return': {
    id: 'product-return',
    name: 'ProductReturn',
    segmentationType: 'REC_ACT',
    segmentationCode: 'RA_RETPRO',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Je souhaite retourner mon article ou ma commande',
      en: 'Return a product',
      de: 'Ein Produkt retournieren',
      es: 'Devolver un producto',
      it: 'Restituire un articolo',
      nl: 'Een artikel retourneren',
      pt: 'Devolver um produto'
    },
    templateType: 3,
    eligibleStatus: ['DELIVERY_IN_PROGRESS', 'DELIVERED', 'DELIVERED_TO_STORE', 'DELIVERED_TO_RELAY'],
    noPictureRequired: true
  },
  'product-not-shipped': {
    id: 'product-not-shipped',
    name: 'ProductNotShipped',
    segmentationType: 'REC_ACT',
    segmentationCode: 'RA_NONLIV',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'ai pas reçu ma commande ou une partie de ma commande",
      en: 'Product or order not delivered',
      de: 'Nicht geliefertes Produkt oder Bestellung',
      es: 'Producto o pedido no entregado',
      it: 'Prodotto o ordine non consegnato',
      nl: 'Product of bestelling niet geleverd',
      pt: 'Produto ou encomenda não entregue'
    },
    templateType: 3,
    eligibleStatus: ['DELIVERED', 'DELIVERED_TO_STORE', 'DELIVERED_TO_RELAY'],
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE, CREDIT_NOTE]
    },
    noPicture: true,
    noPictureRequired: true
  },
  'refuse-product': {
    id: 'refuse-product',
    name: 'RefuseProduct',
    segmentationType: 'REC_ACT',
    segmentationCode: 'RA_REFUS',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "J'ai refusé un produit ou une commande",
      en: 'I refused a product or an order',
      de: 'Ich habe die Lieferung eines Artikels oder einer Bestellung verweigert',
      es: 'He rechazado un producto o un pedido',
      it: 'Ho rifiutato un prodotto o un ordine',
      nl: 'Ik heb een product of een bestelling geweigerd',
      pt: 'Rejeitou um produto ou uma encomenda'
    },
    templateType: 3,
    eligibleStatus: ['DELIVERED', 'DELIVERED_TO_STORE', 'DELIVERED_TO_RELAY'],
    noPictureRequired: true
  },
  'contact-to-refund': {
    id: 'contact-to-refund',
    name: 'ContactToRefund',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CRBST',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Un remboursement',
      en: 'A refund',
      de: 'Eine Rückerstattung',
      es: 'Un reembolso',
      it: 'Un rimborso',
      nl: 'Een terugbetaling',
      pt: 'Contactar consigo em relação a um reembolso'
    },
    userLoggedMandatory: true,
    defaultForm: true
  },
  'absence-during-delivery': {
    id: 'absence-during-delivery',
    name: 'AbsenceDuringDelivery',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_ABSRET',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "J'etais absent lors de ma livraison ou ma commande a été retournée",
      en: "I wasn't at home for my delivery and / or returned order",
      de: 'Ich war bei der Lieferung oder Warenrücksendung nicht da',
      es: 'Estaba ausente en la entrega y/o pedido devuelto',
      it: "Non ero in casa durante la consegna e/o l'ordine è stato restituito ",
      nl: 'Ik was niet aanwezig toen mijn bestelling geleverd werd',
      pt: 'Estava ausente na entrega e/ou a encomenda foi devolvida'
    },
    otherBl: true
  },
  'article-defect': {
    id: 'article-defect',
    name: 'ArticleDefect',
    label: {
      fr: 'Je rencontre un défaut sur mon article qui est sous garantie',
      en: 'I have just noticed a defect in my item, what should I do ?',
      de: 'Mein Artikel weist einen Mangel auf, wie gehe ich vor ?',
      es: 'Acabo de detectar un fallo en mi artículo, ¿qué hago ?',
      it: 'Ho notato un difetto sul mio articolo, cosa devo fare ?',
      nl: 'Ik heb zojuist een defect in mijn artikel opgemerkt, wat moet ik doen ?',
      pt: 'Acabo de detetar uma falha no meu artigo. O que devo fazer ?'
    }
  },
  'invoice-not-received': {
    id: 'invoice-not-received',
    name: 'InvoiceNotReceived',
    label: {
      fr: "Je n'ai pas reçu ma facture",
      en: "I haven't received my invoice",
      de: 'Ich habe meine Rechnung nicht erhalten',
      es: 'No he recibido la factura',
      it: 'Non ho ricevuto la fattura',
      nl: 'Ik heb mijn factuur niet ontvangen',
      pt: 'Não recebi a fatura'
    }
  },
  'modify-invoice-address': {
    id: 'modify-invoice-address',
    name: 'ModifyInvoiceAddress',
    label: {
      fr: 'Je souhaite modifier mon adresse de facturation',
      en: 'I want to modify my billing address',
      de: 'Ich möchte meine Rechnungsadresse ändern',
      es: 'Deseo modificar mi dirección de facturación',
      it: 'Voglio cambiare il mio indirizzo di fatturazione',
      nl: 'Ik wil graag mijn factuuradres wijzigen',
      pt: 'Pretendo modificar o meu endereço de faturação'
    }
  },
  'delivery-question': {
    id: 'delivery-question',
    name: 'DeliveryQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CAUTRECDE',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "La livraison d'une commande",
      en: 'The delivery of an order',
      de: 'Die Lieferung einer Bestellung',
      es: 'Entrega de un pedido',
      it: 'Consegna di un ordine',
      nl: 'Levering van een bestelling'
    },
    defaultForm: true
  },
  'modify-cancel-order-question': {
    id: 'modify-cancel-order-question',
    name: 'modifyCancelOrderQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CAUTRECDE',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "La modification, l'annulation ou le retour d'une commande",
      en: 'Changing, cancelling or returning an order',
      de: 'Die Änderung, Stornierung oder Rückgabe einer Bestellung',
      es: 'Modificación, anulación o devolución de un pedido',
      it: 'Modificare, annullare o restituire un ordine',
      nl: 'Een bestelling wijzigen, annuleren of retourneren'
    },
    defaultForm: true
  },
  'payment-order-question': {
    id: 'payment-order-question',
    name: 'PaymentOrderQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CAUTRECDE',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Le paiement d'une commande",
      en: 'Paying for an order',
      de: 'Die Bezahlung einer Bestellung',
      es: 'Pago de un pedido',
      it: 'Pagamento di un ordine',
      nl: 'Betalen voor een bestelling'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'invoice-question': {
    id: 'invoice-question',
    name: 'InvoiceQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CAUTRECDE',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Une facture',
      en: 'An invoice',
      de: 'Eine Rechnung',
      es: 'Una factura',
      it: 'Una fattura',
      nl: 'Een factuur'
    },
    defaultForm: true
  },
  'other-question': {
    id: 'other-question',
    name: 'OtherQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CAUTRECDE',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je souhaite d'autres informations sur ma commande",
      en: 'I have other questions about my order',
      de: 'Ich habe eine andere Frage zu meiner Bestellung',
      es: 'Tengo otras preguntas sobre mi pedido',
      it: 'Ho altre domande sul mio ordine',
      nl: 'Ik heb andere vragen over mijn bestelling',
      pt: 'Tenho outras perguntas sobre a minha encomenda'
    },
    defaultForm: true,
    optionalBl: true,
    otherBl: true,
    faqButton: true
  },
  'cancel-product-command': {
    id: 'cancel-product-command',
    name: 'CancelProductCommand',
    label: {
      fr: 'Je souhaite annuler un article ou une commande',
      en: 'I want to cancel an item or an order',
      de: 'Ich möchte einen Artikel oder eine Bestellung stornieren',
      es: 'Quiero anular un artículo o un pedido',
      it: 'Desidero cancellare un articolo o un ordine',
      nl: 'Ik wil een artikel of bestelling annuleren',
      pt: 'Pretendo cancelar um artigo ou uma encomenda'
    }
  },
  'modify-shipping-address': {
    id: 'modify-shipping-address',
    name: 'ModifyShippingAddress',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CMODADLIV',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Je souhaite modifier mon adresse de livraison',
      en: 'Changing my delivery address',
      de: 'Meine Lieferadresse ändern',
      es: 'Modificar mi dirección de entrega',
      it: "Modifica l'indirizzo di consegna",
      nl: 'Mijn leveringsadres wijzigen',
      pt: 'Modificar o meu endereço de entrega'
    },
    defaultForm: true
  },
  'add-article': {
    id: 'add-article',
    name: 'AddArticle',
    label: {
      fr: 'Je souhaite ajouter un article',
      en: 'I want to add an item',
      de: 'Ich möchte einen Artikel hinzufügen',
      es: 'Quiero añadir un artículo',
      it: 'Voglio aggiungere un articolo',
      nl: 'Ik wil een artikel toevoegen',
      pt: 'Quero adicionar um artigo'
    }
  },
  'shipping-details': {
    id: 'shipping-details',
    name: 'ShippingDetails',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CMODLIV',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Je souhaite connaitre les modalités de livraison de ma commande',
      en: 'Find out the delivery terms and conditions for my order',
      de: 'Information bezüglich der Liefermodalitäten meiner Bestellung',
      es: 'Conocer las modalidades de entrega de mi pedido',
      it: "Consultare le modalità di consegna dell'ordine",
      nl: 'Wat zijn de leveringsvoorwaarden van mijn bestelling?',
      pt: 'Conhecer as modalidades de entrega da minha encomenda'
    },
    defaultForm: true,
    otherBl: true,
    faqButton: true
  },
  'furniture-received': {
    id: 'furniture-received',
    name: 'FurnitureReceived',
    label: {
      fr: 'Je souhaite connaitre les étapes à suivre lors de la réception de ma commande',
      en: 'What should I do when my furniture is delivered by the carrier ?',
      de: 'Was muss ich bei der Anlieferung der Möbel per Spediteur machen ?',
      es: '¿Qué debo hacer cuando el transportista me entrega los muebles?',
      it: 'Cosa devo fare al momento della ricezione dei mobili consegnati dal corriere ?',
      nl: 'Wat moet ik doen wanner de transporteur mijn meubels komt leveren ?',
      pt: 'O que devo fazer quando a transportadora me entregar os móveis ?'
    }
  },
  'exchange-product': {
    id: 'exchange-product',
    name: 'ExchangeProduct',
    label: {
      fr: 'Je souhaite retourner en magasin un article commandé sur internet',
      en: 'Can I exchange a piece of furniture in store if I ordered it online ?',
      de: 'Kann ich im Internet bestellte Möbel in einer Filiale umtauschen ?',
      es: '¿Puedo cambiar en tienda un mueble comprado en la página web ?',
      it: 'Posso sostituire in negozio un mobile ordinato su Internet ?',
      nl: 'Kan ik in de winkel een meubelstuk omruilen dat ik online gekocht heb ?',
      pt: 'Posso trocar numa loja um móvel comprado na página Web ?'
    },
    faqButton: true
  },
  'gift-card-question': {
    id: 'gift-card-question',
    name: 'GiftCardQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_KDONNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Une carte cadeau',
      en: 'A gift card',
      de: 'Eine Geschenkkarte',
      es: 'Una tarjeta regalo',
      it: 'Una carta regalo',
      nl: 'Een cadeaubon'
    },
    defaultForm: true,
    excludeMiraklBl: true,
    noOrderBl: true
  },
  'gift-card-order-web-not-received': {
    id: 'gift-card-order-web-not-received',
    name: 'GiftCardOrderWebNotReceived',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_KDONNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'ai pas reçu ma carte cadeau commandée sur Internet",
      en: "I haven't received the gift card that I ordered online",
      de: 'Ich habe meine im Internet bestellte Geschenkkarte nicht erhalten',
      es: 'No he recibido mi tarjeta regalo pedida por internet',
      it: 'Non ho ricevuto la mia carta regalo ordinata su Internet',
      nl: 'Ik heb mijn cadeaubon die ik online kocht niet ontvangen',
      pt: 'Não recebi o meu cartão-presente pedido pela Internet'
    },
    userLoggedMandatory: true,
    defaultForm: true,
    excludeMiraklBl: true
  },
  'need-gift-card-invoice': {
    id: 'need-gift-card-invoice',
    name: 'NeedGiftCardInvoice',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_KDOFAC',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "J'ai besoin d'une facture suite à l'achat d'une carte cadeau sur Internet",
      en: 'I need an invoice for the purchase of a gift card online',
      de: 'Ich benötige eine Rechnung für den Kauf einer Geschenkkarte im Internet',
      es: 'Necesito una factura por la compra de una tarjeta regalo en internet',
      it: "Ho bisogno di una fattura a seguito dell'acquisto di una carta regalo su Internet",
      nl: 'Ik heb een factuur nodig voor een online aankoop van een cadeaubon',
      pt: 'Necessito de uma fatura pela compra de um cartão-presente na Internet'
    },
    userLoggedMandatory: true,
    defaultForm: true,
    excludeMiraklBl: true
  },
  'purchase-voucher-lost': {
    id: 'purchase-voucher-lost',
    name: 'PurchaseVoucherLost',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_BAPERDU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "J'ai perdu mon bon d'achat",
      en: "I've lost my purchase voucher",
      de: 'Ich habe meinen Gutschein verloren',
      es: 'He perdido mi vale de compra',
      it: 'Ho perso il mio buono regalo',
      nl: 'Ik ben mijn aankoopbon verloren',
      pt: 'Perdi o meu vale de compra'
    },
    defaultForm: true,
    optionalBl: true,
    otherBl: true,
    excludeMiraklBl: true
  },
  'purchase-voucher-not-received': {
    id: 'purchase-voucher-not-received',
    name: 'PurchaseVoucherNotReceived',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_BANNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'ai pas reçu mon bon d'achat qui devait être envoyé par e-mail ou par courrier",
      en: "I haven't received my purchase voucher that should have been sent by email or post",
      de: 'Ich habe meinen Gutschein nicht erhalten, der per E-Mail oder Post hätte eintreffen müssen',
      es: 'Tenía que haber recibido mi vale de compra por email o por correo',
      it: 'Non ho ricevuto il mio buono regalo che avrebbe dovuto essere stato inviato via email o posta',
      nl: 'Ik heb mijn cadeaubon die via mail of post verzonden zou worden, niet ontvangen',
      pt: 'Devia ter recebido o meu vale de compra por email ou por correio'
    },
    defaultForm: true,
    optionalBl: true,
    otherBl: true,
    excludeMiraklBl: true
  },
  'purchase-voucher-question': {
    id: 'purchase-voucher-question',
    name: 'PurchaseVoucherQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_BANNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Un bon d’achat',
      en: 'A voucher',
      de: 'Ein Gutschein',
      es: 'Un vale',
      it: 'Un buono',
      nl: 'Een waardebon'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'credit-note-not-received': {
    id: 'credit-note-not-received',
    name: 'CreditNoteNotReceived',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_AVOIRNNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'ai pas reçu mon avoir suite à une commande Internet",
      en: "I haven't received my credit note for an online purchase",
      de: 'Ich habe mein Guthaben nach einer Online-Bestellung nicht erhalten',
      es: 'No he recibido mi vale tras haberlo pedido por internet',
      it: 'Non ho ricevuto il mio credito a seguito di un ordine su Internet',
      nl: 'Ik heb mijn bon die ik online bestelde niet ontvangen',
      pt: 'Não recebi o meu vale depois de pedi-lo pela Internet'
    },
    userLoggedMandatory: true,
    defaultForm: true,
    excludeMiraklBl: true
  },
  'lost-credit-note': {
    id: 'lost-credit-note',
    name: 'LostCreditNote',
    label: {
      fr: "J'ai perdu mon avoir",
      en: "I've lost my credit note",
      de: 'Ich habe mein Guthaben verloren',
      es: 'He perdido mi vale de compra',
      it: 'Ho perso il mio credito',
      nl: 'Ik ben mijn tegoedbon verloren',
      pt: 'Perdi o meu vale de compra'
    }
  },
  'credit-question': {
    id: 'credit-question',
    name: 'CreditQuestion',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_AVOIRNNRCU',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Un avoir',
      en: 'A credit note',
      de: 'Eine Gutschrift',
      es: 'Una nota de crédito',
      it: 'Una nota di credito',
      nl: 'Een creditnota'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'cannot-use-gift-card': {
    id: 'cannot-use-gift-card',
    name: 'CannotUseGiftCard',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_KDOKO',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'arrive pas à utiliser ma carte cadeau",
      en: "I can't use my gift card",
      de: 'Ich kann meine Geschenkkarte nicht einlösen',
      es: 'No consigo utilizar mi tarjeta regalo',
      it: 'Non riesco a utilizzare la mia carta regalo',
      nl: 'Ik kan mijn cadeaukaart niet gebruiken',
      pt: 'Não consigo utilizar o meu cartão-presente'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'cannot-use-purchase-voucher': {
    id: 'cannot-use-purchase-voucher',
    name: 'CannotUsePurchaseVoucher',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_BAKO',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'arrive pas à utiliser mon bon d'achat",
      en: "I can't use my purchase voucher",
      de: 'Ich kann meinen Gutschein nicht einlösen',
      es: 'No consigo utilizar mi vale de compra',
      it: 'Non riesco a usare il mio buono regalo',
      nl: 'Ik kan mijn aankoopbon niet gebruiken',
      pt: 'Não consigo utilizar o meu vale de compra'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'cannot-use-credit-note': {
    id: 'cannot-use-credit-note',
    name: 'CannotUseCreditNote',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_AVOIRKO',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: "Je n'arrive pas à utiliser mon avoir",
      en: "I can't use my credit note",
      de: 'Ich kann mein Guthaben nicht einlösen',
      es: 'No consigo utilizar mi vale',
      it: 'Non riesco a usare il mio credito',
      nl: 'Ik kan mijn tegoedbon niet gebruiken',
      pt: 'Não consigo utilizar o meu vale'
    },
    defaultForm: true,
    noOrderBl: true
  },
  rgpd: {
    id: 'rgpd',
    name: 'Rgpd',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_GDPR',
    rootSegmentation: 'GDPR',
    label: {
      fr: "L'exercice de vos droits RGPD",
      en: 'Exercising your GDPR rights',
      de: 'Die Ausübung Ihrer Rechte DSGVO',
      es: 'Ejercicio de sus derechos RGPD',
      it: 'Esercitare i diritti del RGPD',
      nl: 'Uw RGPD-rechten uitoefenen',
      pt: 'Como posso exercer os meus direitos em matéria de proteção dos meus dados pessoais?'
    },
    defaultForm: true,
    noOrderBl: true
  },
  'fabrication-issue': {
    id: 'fabrication-issue',
    name: 'FabricationIssue',
    segmentationType: 'QUEST',
    segmentationCode: 'Q_CMODLIV',
    rootSegmentation: genericRootSegmentation,
    label: {
      fr: 'Un défaut de fabrication sur un produit',
      en: 'A manufacturing defect in a product',
      de: 'Ein Herstellungsfehler an einem Produkt',
      es: 'Un defecto de fabricación en un producto',
      it: 'Un difetto di fabbricazione in un prodotto',
      nl: 'Een fabricagefout in een product'
    },
    defaultForm: true
  }
};
export var RETURN_MOTIFS = {
  id: 'return',
  label: [{
    reason: {
      fr: 'Mon article a subi un dommage pendant le transport',
      en: 'My item has been damaged during transport',
      de: 'Der Artikel wurde während des Transports beschädigt',
      es: 'Mi artículo ha sufrido daños durante el transporte',
      it: "L'articolo ha subito un danno durante il trasporto",
      nl: 'Mijn artikel is beschadigd geraakt tijdens het transport',
      pt: 'O meu artigo sofreu danos durante o transporte'
    },
    subReason: {
      fr: ["L'article a subi un choc", "L'article est complètement cassé"],
      en: ['Impact', 'Broken'],
      de: ['Schlag', 'Bruch'],
      es: ['Choque', 'Roto'],
      it: ['Urto', 'Rottura'],
      nl: ['Stuk', 'Gebroken'],
      pt: ['Choque', 'Partido']
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_CASSE'
  }, {
    reason: {
      fr: "L'article présente un défaut de fabrication à réception",
      en: 'My item had a defect of conformity when received',
      de: 'Der Artikel wies bei der Annahme einen Mangel auf',
      es: 'Mi artículo presenta defectos de conformidad en la recepción',
      it: "L'articolo presenta un difetto di conformità alla ricezione",
      nl: 'Mijn artikel vertoonde een gebrek bij ontvangst',
      pt: 'O meu artigo apresentava defeitos de conformidade na receção'
    },
    subReason: {
      fr: ["L'article est fissuré", "L'article a un défaut sur les coutures ou sur le revêtement", "L'article a un défaut avec le garnissage", "L'article ne fonctionne pas ou ne peut pas être assemblé", "Le tissu de l'article est décoloré", "L'article est bancal"],
      en: ['Lopsided', 'Cracked', 'Problem with stitching / Fabric', 'Discolouration / Colour', 'Filling', 'Mechanism', 'Missing parts'],
      de: ['wackelig', 'rissig', 'Problem mit einer Naht / Einem Stoff', 'Verfärbung / Farbe', 'Polsterung', 'Mechanismus', 'Fehlende teile'],
      es: ['Inestable', 'Fracturado', 'Problema de costura / Tejido', 'Decoloración / Color', 'Relleno', 'Mecanismo', 'Faltan piezas'],
      it: ['Storto', 'Danneggiato', 'Problema di cucitura / Tessuto', 'Decolorazione / Tinta', 'Imbottitura', 'Meccanismo', 'Pezzi mancanti'],
      nl: ['Niet Stabiel', 'Barst', 'Probleem met de naden / Stof', 'Verkleuring / Kleur', 'Vulling', 'Mechanisme', 'Ontbrekende onderdelen'],
      pt: ['Instável', 'Partido', 'Problema de costura / Tecido ', 'Descoloração / Cor', 'Enchimento', 'Mecanismo', 'Faltam peças']
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_NONCONF'
  }, {
    reason: {
      fr: "Un défaut vient d'apparaitre sur mon article",
      en: 'A defect occurred over time',
      de: 'Nach einer gewissen Zeit trat ein Mangel auf',
      es: 'Se ha producido un defecto en el plazo',
      it: 'Un difetto è sopraggiunto nel tempo',
      nl: 'Mijn artikel vertoonde na verloop van tijd een gebrek',
      pt: 'Produziu-se um defeito no prazo'
    },
    subReason: {
      fr: ["L'article est fissuré", "L'article a un défaut sur les coutures ou sur le revêtement", "L'article a un défaut avec le garnissage", "L'article ne fonctionne pas ou ne peut pas être assemblé", "Le tissu de l'article est décoloré", "L'article est bancal"],
      en: ['Lopsided', 'cracked', 'Problem with stitching / Sabric', 'Discolouration / Colour', 'Filling', 'Mechanism', 'Breakage'],
      de: ['Wackelig', 'rissig', 'Problem mit einer Naht / Einem Stoff ', 'Verfärbung / Farbe', 'Polsterung', 'Mechanismus', 'Bruch'],
      es: ['inestable', 'fracturado', 'Problema de costura / Tejido', 'Decoloración / Color', 'Relleno', 'Mecanismo', 'Rotura'],
      it: ['Storto', 'danneggiato', 'Problema di cucitura / Tessuto', 'Decolorazione / Tinta', 'Imbottitura', 'Meccanismo', 'Rottura'],
      nl: ['Niet stabiel', 'Barst', 'Probleem met de naden / Stof', 'verkleuring / Kleur', 'Vulling', 'Mechanisme', 'Gebroken'],
      pt: ['Instável', 'Partido', 'Problema de costura / Tecido ', 'Descoloração / Cor', 'Enchimento', 'Mecanismo', 'Rotura']
    },
    solution: {
      web: [EXCHANGE],
      mag: [EXCHANGE]
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_GARANTIE',
    noReserve: true
  }, {
    reason: {
      fr: "L'article reçu n'était pas celui que j'ai commandé",
      en: 'I did not receive the correct item',
      de: 'Der erhaltene Artikel war nicht der richtige',
      es: 'No he recibido el artículo correcto',
      it: "Non ho ricevuto l'articolo giusto",
      nl: 'Ik heb een verkeerd artikel ontvangen',
      pt: 'Não recebi o artigo correto'
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_ERREURREF'
  }, {
    reason: {
      fr: "L'article reçu ne me convient pas",
      en: "I don't like my item",
      de: 'Der erhaltene Artikel gefiel mir nicht ',
      es: 'Mi artículo no me gusta',
      it: "L'articolo non mi piace",
      nl: 'Het ontvangen artikel beviel me niet',
      pt: 'Não gosto do meu artigo'
    },
    subReason: {
      fr: ["J'ai fait une erreur dans ma commande", 'Les dimensions ne me conviennent pas', 'La couleur ne me convient pas', 'Le style ne me convient pas', 'Le confort ne me convient pas', 'Les finitions ne me conviennent pas', 'La matière ne me convient pas', "La fonctionnalité n'est pas celle attendue", "J'ai reçu l'article trop tard"],
      en: ['Sizes', 'Colour', 'Finishes', 'Style', 'I thought it would work differently', 'Comfort'],
      de: ['Maß', 'Farbe', 'Oberflächen', 'Stil', 'Hatte eine andere Funktion erwartet', 'Comfort'],
      es: ['Tamaño', 'Color', 'acabados', 'Estilo', 'me esperaba una funcionalidad diferente', 'Confort'],
      it: ['Dimensioni', 'Colore', 'Finiture', 'Stile', 'Pensavo che avesse una funzionalità diversa', 'Somfort'],
      nl: ['Afmeting', 'Kleur', 'Afwerkingen', 'Stijl', 'Ik dacht dat het artikel op een andere manier werkte', 'Comfort'],
      pt: ['Tamanho', 'Cor', 'Acabamentos', 'Estilo', 'Esperava uma funcionalidade diferente', 'Conforto']
    },
    solution: {
      web: function web(payments, locale) {
        return getPaymentsEligibleSolutions(payments, locale);
      }
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_CONV',
    noReserve: true,
    checkReturnable: true,
    noPictureRequired: true,
    nonEligibleMag: true,
    isEligibleToRefund: true
  }, {
    reason: {
      fr: "L'article est trop volumineux et ne passe pas",
      en: 'My item was too large to fit',
      de: 'Der Artikel war zu groß',
      es: 'Mi artículo no entra',
      it: "L'articolo non passa",
      nl: 'Mijn artikel is te groot',
      pt: 'O meu artigo não entra'
    },
    subReason: {
      fr: ["L'article ne passe pas dans l'escalier ou l'ascenseur", "L'article ne passe pas dans la pièce dédiée"],
      en: ['Staircase / Lift', 'Room dedicated to the item'],
      de: ['Treppe / Aufzug', 'Spezielles Zimmer für den Artikel'],
      es: ['Escalera / Ascensor', 'Habitación pensada para el artículo'],
      it: ['Scale / Ascensore', "Stanza dedicata all'articolo"],
      nl: ['Trap / Lift', 'Ruimte voor het artikel'],
      pt: ['Escadas / Elevador ', 'Quarto pensado para o artigo']
    },
    solution: {
      web: [CREDIT_NOTE, REFUND],
      mag: [CREDIT_NOTE, REFUND]
    },
    secondarySegmentationType: 'ACT_MOT',
    secondarySegmentationCode: 'AM_PASSAGE',
    creditNoteMag: true,
    noPictureRequired: true
  }]
};
export var REFUSAL_MOTIFS = {
  id: 'refusal',
  label: [{
    reason: {
      fr: 'Mon article a subi un dommage pendant le transport',
      en: 'My item has been damaged during transport',
      de: 'Der Artikel wurde während des Transports beschädigt',
      es: 'Mi artículo ha sufrido daños durante el transporte',
      it: "L'articolo ha subito un danno durante il trasporto",
      nl: 'Mijn artikel is beschadigd geraakt tijdens het transport',
      pt: 'O meu artigo sofreu danos durante o transporte'
    },
    subReason: {
      fr: ["L'article a subi un choc", "L'article est complètement cassé"],
      en: ['Impact', 'Broken'],
      de: ['Schlag', 'Bruch'],
      es: ['Choque', 'Roto'],
      it: ['Urto', 'Rottura'],
      nl: ['Stuk', 'Gebroken'],
      pt: ['Choque', 'Partido']
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    noPictureRequired: true
  }, {
    reason: {
      fr: "L'article présente un défaut de fabrication à réception",
      en: 'My item had a defect of conformity when received',
      de: 'Der Artikel wies bei der Annahme einen Mangel auf',
      es: 'Mi artículo presenta defectos de conformidad en la recepción',
      it: "L'articolo presenta un difetto di conformità alla ricezione",
      nl: 'Mijn artikel vertoonde een gebrek bij ontvangst',
      pt: 'O meu artigo apresentava defeitos de conformidade na receção'
    },
    subReason: {
      fr: ["L'article est fissuré", "L'article a un défaut sur les coutures ou sur le revêtement", "L'article a un défaut avec le garnissage", "L'article ne fonctionne pas ou ne peut pas être assemblé", "Le tissu de l'article est décoloré", "L'article est bancal"],
      en: ['Lopsided', 'Cracked', 'Problem with stitching / Fabric', 'Discolouration / Colour', 'Filling', 'Mechanism', 'Missing parts'],
      de: ['wackelig', 'rissig', 'Problem mit einer Naht / Einem Stoff', 'Verfärbung / Farbe', 'Polsterung', 'Mechanismus', 'Fehlende teile'],
      es: ['Inestable', 'Fracturado', 'Problema de costura / Tejido', 'Decoloración / Color', 'Relleno', 'Mecanismo', 'Faltan piezas'],
      it: ['Storto', 'Danneggiato', 'Problema di cucitura / Tessuto', 'Decolorazione / Tinta', 'Imbottitura', 'Meccanismo', 'Pezzi mancanti'],
      nl: ['Niet Stabiel', 'Barst', 'Probleem met de naden / Stof', 'Verkleuring / Kleur', 'Vulling', 'Mechanisme', 'Ontbrekende onderdelen'],
      pt: ['Instável', 'Partido', 'Problema de costura / Tecido ', 'Descoloração / Cor', 'Enchimento', 'Mecanismo', 'Faltam peças']
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    noPictureRequired: true
  }, {
    reason: {
      fr: "L'article reçu n'était pas celui que j'ai commandé",
      en: 'I did not receive the correct item',
      de: 'Der erhaltene Artikel war nicht der richtige',
      es: 'No he recibido el artículo correcto',
      it: "Non ho ricevuto l'articolo giusto",
      nl: 'Ik heb een verkeerd artikel ontvangen',
      pt: 'Não recebi o artigo correto'
    },
    solution: {
      web: [EXCHANGE, CREDIT_NOTE, REFUND],
      mag: [EXCHANGE]
    },
    noPictureRequired: true
  }, {
    reason: {
      fr: "L'article reçu ne me convient pas",
      en: "I don't like my item",
      de: 'Der erhaltene Artikel gefiel mir nicht ',
      es: 'Mi artículo no me gusta',
      it: "L'articolo non mi piace",
      nl: 'Het ontvangen artikel beviel me niet',
      pt: 'Não gosto do meu artigo'
    },
    subReason: {
      fr: ["J'ai fait une erreur dans ma commande", 'Les dimensions ne me conviennent pas', 'La couleur ne me convient pas', 'Le style ne me convient pas', 'Le confort ne me convient pas', 'Les finitions ne me conviennent pas', 'La matière ne me convient pas', "La fonctionnalité n'est pas celle attendue", "J'ai reçu l'article trop tard"],
      en: ['Sizes', 'Colour', 'Finishes', 'Style', 'I thought it would work differently', 'Comfort'],
      de: ['Maß', 'Farbe', 'Oberflächen', 'Stil', 'Hatte eine andere Funktion erwartet', 'Comfort'],
      es: ['Tamaño', 'Color', 'acabados', 'Estilo', 'me esperaba una funcionalidad diferente', 'Confort'],
      it: ['Dimensioni', 'Colore', 'Finiture', 'Stile', 'Pensavo che avesse una funzionalità diversa', 'Somfort'],
      nl: ['Afmeting', 'Kleur', 'Afwerkingen', 'Stijl', 'Ik dacht dat het artikel op een andere manier werkte', 'Comfort'],
      pt: ['Tamanho', 'Cor', 'Acabamentos', 'Estilo', 'Esperava uma funcionalidade diferente', 'Conforto']
    },
    solution: {
      web: function web(payments, locale) {
        return getPaymentsEligibleSolutions(payments, locale);
      },
      mag: [CREDIT_NOTE]
    },
    noPictureRequired: true
  }, {
    reason: {
      fr: "L'article est trop volumineux et ne passe pas",
      en: 'My item was too large to fit',
      de: 'Der Artikel war zu groß',
      es: 'Mi artículo no entra',
      it: "L'articolo non passa",
      nl: 'Mijn artikel is te groot',
      pt: 'O meu artigo não entra'
    },
    subReason: {
      fr: ["L'article ne passe pas dans l'escalier ou l'ascenseur", "L'article ne passe pas dans la pièce dédiée"],
      en: ['Staircase / Lift', 'Room dedicated to the item'],
      de: ['Treppe / Aufzug', 'Spezielles Zimmer für den Artikel'],
      es: ['Escalera / Ascensor', 'Habitación pensada para el artículo'],
      it: ['Scale / Ascensore', "Stanza dedicata all'articolo"],
      nl: ['Trap / Lift', 'Ruimte voor het artikel'],
      pt: ['Escadas / Elevador ', 'Quarto pensado para o artigo']
    },
    solution: {
      web: [CREDIT_NOTE, REFUND],
      mag: [CREDIT_NOTE, REFUND]
    },
    noPictureRequired: true
  }]
};